import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>세무회계 <span className="highlight">결</span></h3>
            <p>세무 서비스를<br />제공하는 전문가 그룹</p>
            <div className="footer-contact">
              <p>📞 02-6949-5003</p>
              <p>📧 tax_gyeol@naver.com</p>
              <p>📍 서울특별시 중랑구 망우로 177, 3층 (중화동, 삼성빌딩)</p>
            </div>
          </div>

          <div className="footer-section services-section">
            <h4>주요 서비스</h4>
            <ul>
              <li>종합소득세 신고</li>
              <li>부가세 신고</li>
              <li>법인세 신고</li>
              <li>세무조사 대응</li>
              <li>장부작성 및 기장대리</li>
              <li>세무상담</li>
            </ul>
          </div>

          <div className="footer-section desktop-only">
            <h4>바로가기</h4>
            <ul>
              <li><Link to="/">홈</Link></li>
              <li><Link to="/about">회사소개</Link></li>
              <li><Link to="/services">업무소개</Link></li>
              <li><Link to="/correction">경정청구</Link></li>
              <li><Link to="/contact">상담문의</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>운영시간</h4>
            <ul>
              <li>전화상담: 평일 09:00 - 18:00</li>
              <li>카톡상담: 평일 11:00 - 16:00</li>
              <li className="desktop-only">토요일/일요일/공휴일: 휴무</li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; 2021 세무회계 결. All rights reserved.</p>
            <div className="footer-links">
              <Link to="/privacy">개인정보처리방침</Link>
              <a href="#terms">이용약관</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
